<template>
  <div class="sales-per-store">
    <h2 class="h1 card-group-title">
      {{ $t('product.sales-per-store-title') }}
    </h2>
    <sales-per-store-skeleton v-if="$_verifyLoaded('loading')" :data="data" :type="type" />
    <table-list
      :id="id"
      :data="data"
      :type="type"
      :empty="!data.count"
      :loading="$_verifyLoaded('loading')"
      :info="$_verifyLoaded('info')"
    >
      <table-list-header v-show="$_verifyLoaded('done')">
        <table-list-column order="store_name" class-name="col-6">{{ $tc('product.store', 1) }}</table-list-column>
        <table-list-column order="product_quantity" class-name="col-2 text-right">{{
          $t('product.product_quantity')
        }}</table-list-column>
        <table-list-column order="product_asp" class-name="col-2 text-right">{{
          $t('product.avg-price')
        }}</table-list-column>
        <table-list-column order="product_revenue" class-name="col-2 text-right">{{
          $t('product.total')
        }}</table-list-column>
      </table-list-header>
      <table-list-body>
        <template v-if="$_verifyLoaded('done')">
          <table-list-row v-for="(store, index) in data.rows" :key="index">
            <table-list-column class-name="store col-6">{{ store.store }}</table-list-column>
            <table-list-column class-name="col-2 text-right">{{ store.quantity }}</table-list-column>
            <table-list-column class-name="col-2 text-right">
              {{ formatCurrency(store.avgPrice) }}
            </table-list-column>
            <table-list-column class-name="col-2 text-right">
              {{ formatCurrency(store.totalRevenue) }}
            </table-list-column>
          </table-list-row>
        </template>
        <info-card v-show="$_verifyLoaded('info')" ref="message-error" :error="hasError" />
      </table-list-body>
    </table-list>
  </div>
</template>

<script>
import { getTable } from '@/services/product';

import bus from '@/helpers/events/bus';
import { verifyMixin, numberMixin } from '@/helpers/mixins';

import InfoCard from '@/components/_atoms/InfoCard';
import SalesPerStoreSkeleton from '@/components/products/product/ProductSalesPerStoreSkeleton';

export default {
  components: {
    'sales-per-store-skeleton': SalesPerStoreSkeleton,
    InfoCard,
  },
  mixins: [verifyMixin, numberMixin],
  props: {
    productID: {
      type: String,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      id: 'sales-per-store',
      data: {
        loading: true,
        page: 1,
        limit: 10,
        count: 0,
        rows: [],
        series: [],
        order: 'store_name',
        orderDefault: 'store_name',
      },
      type: 'filled',
    };
  },
  mounted() {
    this.fetchData();

    bus.$on(`${this.id}-change-page`, () => {
      this.$_reqConfig();
      this.fetchData();
    });
    bus.$on(`${this.id}-change-order`, this.fetchData);

    bus.$on('render-cards', this.fetchData);
  },
  beforeUnmount() {
    bus.$off('render-cards', this.fetchData);
  },
  methods: {
    fetchData() {
      this.$_reqConfig();

      getTable({
        table: 'sales_per_store',
        productID: this.productID,
        limit: this.data.limit,
        page: this.data.page,
        orderBy: this.data.order,
      })
        .then(({ data }) => {
          if (this.$_verifyData(data.data)) return;

          this.data.count = data.total_count;
          this.data.series = data.series;
          this.formatRows(data.data);
        })
        .catch(() => {
          this.data.count = 0;
          this.data.rows = [];
          this.data.series = [];
          this.hasError = true;
          this.$_componentHeight();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatRows(data) {
      function ROW(row) {
        [this.store, this.quantity, this.avgPrice, this.totalRevenue] = row;
      }

      this.data.rows = [];
      for (let i = 0; i < data.length; i += 1) {
        this.data.rows.push(new ROW(data[i]));
      }
    },
  },
};
</script>
